const PREFERENCES = {
    DESKTOP: 'desktop',
    MOBILE: 'mobile',
    NONE: 'default',
    KEY: 'view',
};

const getUserPreference = () => localStorage.getItem(PREFERENCES.KEY) || PREFERENCES.NONE;

export const setDesktopMode = () => localStorage.setItem(PREFERENCES.KEY, PREFERENCES.DESKTOP);
export const clearDesktopMode = () => localStorage.setItem(PREFERENCES.KEY, PREFERENCES.NONE);

export const shouldBeMobile = () => {
    // create the temp element we need to test Bootstrap.
    const tempTestingElement = document.createElement('div');
    tempTestingElement.className = 'd-md-none';
    document.body.appendChild(tempTestingElement);

    // figure out if it's visible on the screen right now.
    const result = !!(tempTestingElement.offsetWidth || tempTestingElement.offsetHeight || tempTestingElement.getClientRects().length);

    // get rid of the temporary element.
    document.body.removeChild(tempTestingElement);
    return result;
};

export const isMobile = () => ((getUserPreference() === PREFERENCES.DESKTOP) ? false : shouldBeMobile());

export default {
    isMobile,
    shouldBeMobile,
    getUserPreference,
    setDesktopMode,
    clearDesktopMode,
};
